<template>
	<div class="Login">
		<div class="LoginMethod">
			<!-- 优先验证码登录 -->
			<template v-if="is_priority_verification_code_login">
				<div
					v-if="loginMethodConfig === 'code' || loginMethodConfig === 'all'"
					@click="SwitchingMethod('Verification')"
					class="Method fl"
					:class="{ highlight: !loginMethod }"
				>
					验证码登录<span v-show="!loginMethod"></span>
				</div>

				<div class="fl cutApart" v-if="loginMethodConfig === 'all'"></div>

				<div
					v-if="loginMethodConfig === 'password' || loginMethodConfig === 'all'"
					@click="SwitchingMethod('password')"
					class="Method fl"
					:class="{ highlight: loginMethod }"
				>
					密码登录<span v-show="loginMethod"></span>
				</div>
			</template>

			<template v-else>
				<div
					v-if="loginMethodConfig === 'password' || loginMethodConfig === 'all'"
					@click="SwitchingMethod('password')"
					class="Method fl"
					:class="{ highlight: loginMethod }"
				>
					密码登录<span v-show="loginMethod"></span>
				</div>

				<div class="fl cutApart" v-if="loginMethodConfig === 'all'"></div>

				<div
					v-if="loginMethodConfig === 'code' || loginMethodConfig === 'all'"
					@click="SwitchingMethod('Verification')"
					class="Method fl"
					:class="{ highlight: !loginMethod }"
				>
					验证码登录<span v-show="!loginMethod"></span>
				</div>
			</template>

			<div class="clear"></div>
		</div>
		<div class="EditingArea">
			<div v-show="loginMethod" class="vanField">
				<ul>
					<li>
						<van-field v-model="phone" center clearable :border="false" use-button-slot :placeholder="'请输入' + placeholderTxt" />
					</li>
					<li class="passwordInputWrapper">
						<van-field v-model="password" class="passwordStyle fl" clearable :type="isVisible" placeholder="请输入登录密码" :border="false" />

						<div class="VisibleCutApart fl"></div>

						<div class="Visible fr" @click="setVisible">
							<img class="fl" :src="isVisibleImg" alt="" />
						</div>

						<div class="clear"></div>
					</li>
				</ul>
			</div>
			<div v-show="!loginMethod" class="vanField">
				<ul>
					<li>
						<van-field v-model="phone" center clearable :border="false" use-button-slot :placeholder="'请输入' + placeholderTxt" />
					</li>
					<li class="authcodeInputWrapper">
						<van-field v-model="Verification" maxlength="6" class="VerificationStyle fl" clearable placeholder="请输入验证码" :border="false" />

						<div
							class="getVerificationStyle fr"
							@click="postAccountGetAuthCode"
							:style="{
								color: Countdown > 0 ? '#BBBBBB' : '#333333',
							}"
						>
							{{ VerificationStatus }}
						</div>

						<div class="clear"></div>
					</li>
				</ul>
			</div>
		</div>
		<div class="OperatingSpace">
			<van-button round type="info" :class="phone && protocol ? 'van-button--info' : 'noneVanButton'" @click="handleLogin">登录</van-button>
			<div class="protocolStyle" :class="theme=='renshefenguan'?'renProtoStyle':''">
				<van-checkbox v-model="protocol" label-disabled class="myCheckbox"></van-checkbox>
				<span @click="ClearanceAgreement">我同意</span>
				<template v-if="theme!='renshefenguan'">
					<a @click="goPage(1)">《用户协议》</a>
					<span>及</span>
					<a @click="goPage(2)">《法律声明及隐私政策》</a>
				</template>
				<template v-else>
					<a @click="goPage('registerProtocol')">《用户注册协议》</a><a @click="goPage('user-privacy')">《个人信息保护制度》</a>
					<a @click="goPage('network-regulation')">《网络安全管理制度》</a>
				</template>
				<div class="clear"></div>
			</div>

			<div class="botton-btn">
				<!-- <span class="item left" v-if="canRegister" @click="toRouter('/registered')">立即注册</span> -->
				<span class="item left" v-if="canRegister && theme!='renshefenguan'" @click="toRouter('/registered')">立即注册</span>

				<span class="item right" @click="toRouter('/verification')">忘记密码</span>
				<div class="clear"></div>
			</div>
		</div>
	</div>
</template>
<script>
/* eslint-disable */
import config from './../../../config/url'
import yincang from '../../../assets/images/account/icon-yincang.png'
import xianshi from '../../../assets/images/account/icon-xianshi.png'
import md5 from 'js-md5'
import store from '../../../store'
import { mapState } from "vuex";
const isPhone = /^1(?:3[0-9]|4[5-9]|5[0-9]|6[124567]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/
const isEmail = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
const isIdentitycard =
	/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
const agentHost =
	"'agent.saas-h5.testing2.wdeduc.com', 'agent.saas-h5.testing3.wdeduc.com', 'agent.fat.wdeduc.com' , 'agent.uat.wdeduc.com' , 'agent.wdeduc.com', 'localhost:80'"
export default {
	name: 'login',
	data() {
		return {
			protocol: false,
			phone: this.$route.query.phone,
			password: null,
			Verification: null,
			Countdown: 0,
			countdownInterval: null,
			isVisible: 'password',
			place: 'password',
			loginMethodList: ['1', '2', '3', '4', '5'], //1,3验证码，1手机号3邮箱，           2，4，5密码 ，2手机号，4邮箱， 5身份证
			loginMethodConfig: 'all',
			logintxt: '手机号码/邮箱/身份证号码',
			canRegister: false,
			haveSavedDetailFlag: true, //判断是否保存过
			isAllowStudentNumberLogin: false, //是否允许校号登录（青岛恒星）
			branchId: '', // 机构id
			branchUcode: '', // 机构UCode
      user_agreement_url:'https://wd-static-page.wdeduc.com/wdn-h5-agreement/service-agreement.html',
      privacy_policy_url:'https://wd-static-page.wdeduc.com/wdn-h5-agreement/privacy.html',
			// yingjiBranchUcodeObj: {
			// 	//应急山东省branchucode
			// 	fat: '07d8921704f542b4bd71844e96dab70b',
			// 	uat: '56fe2ebe68cd4c799733b9f350cd81f9',
			// 	prod: 'c5d86774b74149f0ab77d58034004250',
			// },
			// yingjiGmBranchUcodeObj: {
			// 	//应急工贸培训branchucode
			// 	fat: '6cb2d6910c494d3f93a93d13c8a92700',
			// 	uat: 'bfca586d2ca04de3b3f670fa33e931ac',
			// 	prod: 'e17c634bc0eb40e4a86c896f51c5ddd9',
			// },
			// yingjiSlfhBranchUcodeObj: {
			// 	fat: "5e905624cc674f29a5f681905cd5c457",
			// 	uat: "ec168785e2834f258d82565e37eca396",
			// 	prod: "e2fb99d769894f8b955b72279c937b83",
			// },
			// feimeiBranchUcodeObj:{
			// 		//应急非煤培训branchucode
			// 		fat: '3bd092d9e2f9439fad76f732d00c4177',
			// 		uat: "53b55255ceb54028802fbabf3f33ba0c",
			// 		prod: "3efd741de4f7465685df29f1ce14ff31",
			// },
			rensheDistributionIsAuth:false, //人社分管营销考试平台：检测是否已完善考试认证信息
		}
	},
	computed: {
		theme() {
			return this.$store.state.dynamic.theme
		},
		...mapState(['rsDistribution']),
		loginMethod() {
			return this.place === 'password'
		},
		isVisibleImg() {
			return this.isVisible === 'password' ? yincang : xianshi
		},
		VerificationStatus() {
			if (this.Countdown) {
				return `重新获取 ${this.Countdown}s`
			} else {
				return '发送验证码'
			}
		},
		placeholderTxt() {
			if (this.isAllowStudentNumberLogin) {
				return '校号/手机号/邮箱/身份证号码'
			}
			if (this.loginMethodConfig === 'code' && this.logintxt.includes('身份证')) {
				let index = this.logintxt.lastIndexOf('/')
				return this.logintxt.slice(0, index)
			} else if (this.loginMethodConfig === 'all' && this.place === 'password') {
				let strToArr = this.logintxt.split('/')
				if (!this.loginMethodList.includes('2') && this.logintxt.includes('手机号码')) {
					let index = strToArr.indexOf('手机号码')
					strToArr.splice(index, 1)
				}
				if (!this.loginMethodList.includes('4') && this.logintxt.includes('邮箱')) {
					let index = strToArr.indexOf('邮箱')
					strToArr.splice(index, 1)
				}
				return strToArr.join('/')
			} else if (this.loginMethodConfig === 'all' && this.place === 'Verification') {
				let strToArr = this.logintxt.split('/')
				let ind = strToArr.indexOf('身份证号码')
				if (ind != -1) {
					strToArr.splice(ind, 1)
				}
				if (!this.loginMethodList.includes('1') && this.logintxt.includes('手机号码')) {
					let index = strToArr.indexOf('手机号码')
					strToArr.splice(index, 1)
				}
				if (!this.loginMethodList.includes('3') && this.logintxt.includes('邮箱')) {
					let index = strToArr.indexOf('邮箱')
					strToArr.splice(index, 1)
				}
				return strToArr.join('/')
			} else {
				return this.logintxt
			}
		},
		is_login_current_branch() {
			let is_login_current_branch = this.$store.state.dynamic.frontendConfig.find((item) => item.key === 'is_login_current_branch')
			if (is_login_current_branch) {
				if (is_login_current_branch.value === 'true') {
					return true
				}
			}
			return false
		},
		is_priority_verification_code_login() {
			let is_priority_verification_code_login = this.$store.state.dynamic.frontendConfig.find(
				(item) => item.key === 'is_priority_verification_code_login'
			)
			if (is_priority_verification_code_login) {
				if (is_priority_verification_code_login.value === 'true') {
					return true
				}
			}
			return false
		},
		/* 行业标签
            meet_emergency    应急
        */
		branchIndustry() {
			return this.$store.state.dynamic.pageSetData.branchIndustry
		},
		yingjiBranchUcode() {
			//应急山东省branchucode
			// let envArr = ['fat', 'uat']
			// let env = 'prod'
            //  envArr.forEach((d) => {
			// 	if (window.location.hostname.includes(d)) {
			// 		env = d
			// 	}
			// })
			// 应急登录定制化配置
			let devOptions = localStorage.getItem('devOptions')
			if(devOptions && devOptions.length){
				devOptions = JSON.parse(devOptions)[0]
				return devOptions.branchUcode 
				// if(devOptions.sign === 'gongmao'){
				// 	console.log('gongmao--------------------------')
				// 	return this.yingjiGmBranchUcodeObj[env]
				// }else if(devOptions.sign === 'weihua'){
				// 	console.log('weihua---------------------------')
				// 	return this.yingjiBranchUcodeObj[env]
				// }else if(devOptions.sign === 'slfh'){
				// 	console.log('slfh---------------------------')
				// 	return this.yingjiSlfhBranchUcodeObj[env]
				// }else if(devOptions.sign === 'feimei'){
				// 	console.log('feimei---------------------------')
				// 	return this.feimeiBranchUcodeObj[env]
				// }
			}
			return ''
		},
	},
	created() {
		const branchId = localStorage.getItem('branchId')
		const branchUcode = localStorage.getItem('branchUcode')
		this.branchId = branchId
		this.branchUcode = branchUcode
		this.initConfig()
	},
	destroyed() {
		window.removeEventListener('popstate', this.backChange, false) //false阻止默认事件
	},
	mounted() {
		let seach = window.location.search && window.location.search.split('?')[1].split('&')
		let obj = {}
		seach &&
			seach.forEach((item) => {
				let [key, val] = item.split('=')
				obj[key] = val
			})
		this.phone = obj.phone || sessionStorage.getItem('WdPhone') || null
		console.log(this.phone)

		window.addEventListener('popstate', this.backChange, false) //false阻止默认事件
	},
	methods: {
		getConfigurationNew() {
			this.$api.configuration.getConfigurationNew().then((data) => {
				if (data.data) {
					let temp = {
						pageHeader: data.data.pageHeader,
						pageHeaderSetting: data.data.pageHeaderSetting,
						pageEndSetting: data.data.pageEndSetting,
						pageEnd: data.data.pageEnd,
						pageUrlList: data.data.pageUrlList,
					}
					localStorage.setItem('setTempConfigs', JSON.stringify(temp))
				}
			})
		},
		ClearanceAgreement() {
			this.protocol = !this.protocol
		},
		//   用户协议跳转页面
		goPage(url) {
      if(url == 1){
        window.open(this.user_agreement_url)
      }else if(2){
        window.open(this.privacy_policy_url)
      }else{
			  this.$router.push(url)
      } 
		},
		initConfig() {
			/*
                手机号+验证码 is_allow_telephone_verification_code_login 1
                手机号+密码   is_allow_telephone_password_login 2
                邮箱+验证码   is_allow_email_verification_code_login 3
                邮箱+密码     is_allow_email_password_login 4
                身份证+密码   is_allow_id_number_password_login 5
                注册方式:手机号+验证码  is_allow_telephone_register
                注册方式:邮箱+验证码    is_allow_email_register
            */
			let frontendConfig = this.$store.state.dynamic.frontendConfig || []
			frontendConfig.length &&
				frontendConfig.forEach((item) => {
					switch (item.key) {
            case 'privacy_policy_url':
              this.privacy_policy_url = item.value || this.privacy_policy_url;
              break;
            case 'user_agreement_url':
              this.user_agreement_url = item.value || this.user_agreement_url;
              break;
						case 'is_open_register':
							this.canRegister = item.value === 'true' ? true : false
							break
						case 'is_allow_student_number_password_login':
							if (item.value === 'true') {
								this.isAllowStudentNumberLogin = true
							}
							break
						case 'is_allow_telephone_verification_code_login':
							if (item.value === 'false') {
								let index = this.loginMethodList.indexOf('1')
								this.loginMethodList.splice(index, 1)
							}
							break
						case 'is_allow_telephone_password_login':
							if (item.value === 'false') {
								let index = this.loginMethodList.indexOf('2')
								this.loginMethodList.splice(index, 1)
							}
							break
						case 'is_allow_email_verification_code_login':
							if (item.value === 'false') {
								let index = this.loginMethodList.indexOf('3')
								this.loginMethodList.splice(index, 1)
							}
							break
						case 'is_allow_email_password_login':
							if (item.value === 'false') {
								let index = this.loginMethodList.indexOf('4')
								this.loginMethodList.splice(index, 1)
							}
							break
						case 'is_allow_id_number_password_login':
							if (item.value === 'false') {
								let index = this.loginMethodList.indexOf('5')
								this.loginMethodList.splice(index, 1)
							}
							break
						default:
							break
					}
				})
			this.handleLoginTxt()
		},
		handleLoginTxt() {
			let result = '手机号码/邮箱/身份证号码'
			if (!this.loginMethodList.includes('1') && !this.loginMethodList.includes('3')) {
				//密码
				result = this.getMethodTxt()
				this.loginMethodConfig = 'password'
			} else if (!this.loginMethodList.includes('2') && !this.loginMethodList.includes('4') && !this.loginMethodList.includes('5')) {
				//验证码
				result = this.getMethodTxt()
				this.loginMethodConfig = 'code'
				this.place = 'Verification'
			} else {
				//验证码+密码
				result = this.getMethodTxt()
				this.loginMethodConfig = 'all'
				if (this.is_priority_verification_code_login) {
					this.place = 'Verification'
				}
			}
			this.logintxt = result
		},
		getMethodTxt() {
			let hasphone,
				hasemail,
				hasidentifycard = ''
			if (this.loginMethodList.includes('1') || this.loginMethodList.includes('2')) hasphone = '手机号码'
			if (this.loginMethodList.includes('3') || this.loginMethodList.includes('4')) hasemail = '邮箱'
			if (this.loginMethodList.includes('5')) hasidentifycard = '身份证号码'
			let arr = [hasphone, hasemail, hasidentifycard].filter((item) => {
				return !!item
			})
			return arr.join('/')
		},
		toRouter(path) {
			const query = { ...this.$route.query }
			this.$router.push({ path, query })
		},
		SwitchingMethod(val) {
			this.place = val
		},
		setVisible() {
			if (this.isVisible === 'password') {
				this.isVisible = 'text'
				return 0
			}
			this.isVisible = 'password'
		},
		setCountdown() {
			this.countdownInterval = setInterval(() => {
				this.Countdown--
				if (this.Countdown <= 0) {
					this.Countdown = 0
					clearInterval(this.countdownInterval)
				}
			}, 1000)
		},
		postAccountGetAuthCode() {
			if (this.Countdown > 0) return
			const data = { account: this.phone, type: 1 }
			if (isPhone.test(this.phone) || isEmail.test(this.phone)) {
				this.Countdown = 60
				this.setCountdown()
				this.$sensors.track('UM_Click_Verification _Code_Button')
				this.$api.usercenter.getAuthCodeCommon({ data }).then((res) => {
					if (res.data) {
						this.$store.state.userInfo.phone = this.phone
						sessionStorage.setItem('WdPhone', this.phone)
					}
				})
			} else {
				this.$notify({
					type: 'warning',
					message: this.placeholderTxt + '格式有误,请检查一下吧',
				})
			}
		},
		async handleLogin() {
			if (!this.protocol) return
			// 保证本地存储最新的
			localStorage.removeItem('code')
			localStorage.removeItem('organ')
			localStorage.removeItem('actor')
			localStorage.removeItem('branch')
			localStorage.removeItem('channel')
			const data = {
				account: this.phone,
				password: md5(this.password),
				authCode: this.Verification,
			}
      const registerChannel = sessionStorage.getItem('registerChannel2')
      if(registerChannel){
        const tempRegisterChannel = JSON.parse(registerChannel)
        data.registerChannel = registerChannel
        data.recommendUserUcode = tempRegisterChannel.recommendUserUcode
      }
			let method = ''
			if (this.place === 'password') {
				//密码登录
				method = 'postAccountLogin'
			} else if (this.is_login_current_branch) {
				//验证码登录（没有账号直接注册到当前机构）
				method = 'login2Branch'
				data.branchUcode = this.branchUcode
			} else {
				method = 'postAccountLoginByAuthCode'
			}

			this.$store.state.distributionId && (data.distributionId = this.$store.state.distributionId)
			await this.$api.usercenter[method]({ data }).then(async (res) => {
				if (res.data) {
					localStorage.setItem('token', res.data)

					//分校信息接口，返回信息作用于checkSaveDetail接口请求头，影响返回值
					let branchRes = []
					try {
						branchRes = await this.$api.account.getFindUserBranchList({})
					} catch (error) {
						if (error) {
							localStorage.removeItem('token')
							return
						}
					}
					if (branchRes.data && branchRes.data.length) {
						let currentBranch = branchRes.data[0]
						if (this.branchIndustry === 'meet_emergency'&&this.$route.query.projectName!=='yuye') {// 应急定制登录
							// 登录山东省机构
                                currentBranch = branchRes.data.find((item) => {
                                    return item.branchUcode === this.yingjiBranchUcode
                                })
						} else if (this.is_login_current_branch) {
							// 登录域名指定的子机构
							currentBranch = branchRes.data.find((item) => {
								let branch = md5(this.branchId + item.token).toUpperCase()
								return item.branch === branch
							})
						}
						if (!currentBranch) {
							this.$notify({
								type: 'warning',
								message: '暂未加入到当前机构！',
							})
							localStorage.removeItem('token')
							return
						}

						localStorage.setItem('code', currentBranch.code)
						localStorage.setItem('organ', currentBranch.organ)
						localStorage.setItem('actor', currentBranch.actor)
						localStorage.setItem('branch', currentBranch.branch)
						currentBranch.channel && localStorage.setItem('channel', currentBranch.channel)
						this.$sensors.login(currentBranch.code)
					} else {
						localStorage.removeItem('token')
						return
					}

					// 获取用户信息
					// this.getUserInfo()
					 let userInfoRes=await this.$api.usercenter.getAccountUserInfo({});
					 localStorage.setItem('WDuserInfo', JSON.stringify(userInfoRes.data))
					 this.$store.commit('setUserInfo', userInfoRes.data)

					// 获取用户id
					this.findUserId()

					//人社分管营销考试平台定制：检查是否已完善考试认证信息（包含实名认证），否->考试认证页面
					if(localStorage.getItem('theme') === 'renshefenguan' && userInfoRes.data){
						const res2 = await this.$api.rensheDistributionExam.findUserAnnexByParam({ucode:userInfoRes.data.userUcode});
						if(res2.code ==0 && res2.success){
							this.rensheDistributionIsAuth= res2.data && Array.isArray(res2.data)&&res2.data.length>0;
							this.$store.commit('setRsDistribution', this.rensheDistributionIsAuth)
						}
					}


					setTimeout(() => {
						//人社分管营销考试平台定制
						if(localStorage.getItem('theme') === 'renshefenguan'){
							if( this.rensheDistributionIsAuth && userInfoRes.data.idAuthStatus && userInfoRes.data.faceAuthStatus ){
								this.$router.push('/saccount');
							}else{
								this.$router.replace("/rensheMyProfile?type=auth");
							}

						}else if (sessionStorage.getItem('realName')) {
							location.replace('/idcard')
						} else {
							// 应急首页、登录定制化配置
							let devOptions = localStorage.getItem('devOptions')
							let homepage = ''
							if (devOptions && devOptions.length) {
									devOptions = JSON.parse(devOptions)[0]
									homepage =  '/' + devOptions.sign
							}
							// 应急定制化首页
							if(homepage){
								this.$router.push(homepage)
							}else if (this.$route.query.name) {
								if (sessionStorage.getItem('search') && this.$route.query.name === 'goodsDetail') {
									location.replace(this.$route.query.name + sessionStorage.getItem('search'))
								} else {
									let search = null
									if (window.location.search) {
										search = window.location.search
									}
									location.replace(this.$route.query.name + search)
								}
							} else {
								let frontendConfig = this.$store.state.homepage || []
								if (frontendConfig.length && frontendConfig[0].value) {
									console.log('route++++++', frontendConfig[0].value)
									this.$router.push(frontendConfig[0].value)
								} else {
									this.$router.push('/home')
								}
							}
						}
					}, 50)
				}
			})
		},
		getUserInfo() {
			this.$api.usercenter.getAccountUserInfo({}).then((res) => {
				localStorage.setItem('WDuserInfo', JSON.stringify(res.data))
				this.$store.commit('setUserInfo', res.data)
			})
		},
		// 查询用户id
		findUserId() {
			this.$api.usercenter.findUser().then((res) => {
				if (res.code == 0) {
					let subUser = { id: res.data.id }
					localStorage.setItem('subUserInfo', JSON.stringify(subUser))
				}
			})
		},

		backChange() {
			const agentHost =
				"'agent.saas-h5.testing2.wdeduc.com', 'agent.saas-h5.testing3.wdeduc.com', 'agent.fat.wdeduc.com' , 'agent.uat.wdeduc.com' , 'agent.wdeduc.com'"

			if (agentHost.includes(window.location.hostname)) {
				//location.reload();
				this.$router.replace({
					path: '/login',
					query: {
						name: 'promotionCenter',
						type: new Date().getMinutes(),
					},
				})
			}
		},
	},
}
</script>
<style lang="stylus" scoped>
.botton-btn
  display flex
  .item
    flex 1
  .left
    text-align: left
  .right
    text-align: right
div.renProtoStyle{
	white-space:normal;
}
.protocolStyle{
    // margin-top 48px
    margin-bottom 24px
    white-space:nowrap
    /deep/.van-checkbox{
      margin-right 8px
      display:inline-block;
      vertical-align: middle
    }
    span, a{
      display inline-block
      font-size 26px !important
      line-height 30px
      margin-top 6px
    }
    span {
      color #666666
    }
    a {
      color #3760FF
    }
  }

.Login{
  background-color #FFFFFF
  min-height 100vh
}
.LoginMethod {
  padding-left 32px
  padding-top 122px
  .Method {
    padding 0 32px
    font-size 44px
    font-weight 900
    color #BBBBBB
    position relative
    span {
      width 48px
      height 8px
      display inline-block
      background-color #3660FF
      border-radius 4px
      position absolute
      margin-left -24px
      bottom -24px
      left 50%
    }
    &.highlight {
      color #333333
    }
  }
  .cutApart {
    width  2px
    height 44px
    margin-top 10px
    border-radius 1px
    background-color #D7D7D7
  }
}
.EditingArea{
  width 622px
  padding-top 55px
  position relative
  margin-left -311px
  left 50%
  li {
    padding 1px 0
    height 122px
    overflow hidden
    border-bottom 1px solid #D7D7D7
    .passwordStyle{
      width 548px
      display inline-block
    }
    .VisibleCutApart{
      margin 0 24px
      width  2px
      height 32px
      border-radius 1px
      background-color #D7D7D7
    }
    .Visible{
      display inline-block
      img{
        width 48px
      }
    }
  }
  li.passwordInputWrapper{
    display flex
    align-items center
  }
  li.authcodeInputWrapper{
    display flex
    align-items center
    justify-content space-between
  }
  .van-cell{
    padding 0
    height 58px
    line-height 58px
    font-size 18px
    background transparent
  }
}
.OperatingSpace{
  width 622px
  position relative
  margin-left -311px
  left 50%
  span{
    color #333333
    font-size 30px
  }
  .van-button{
    width 100%
    height 44px
    line-height 44px
    margin-top 32px
    margin-bottom 24px
    span{
      color #FFFFFF
      font-size 16px
    }
  }
  .noneVanButton{
    background-color #C0D5FF
    border 1px solid #C0D5FF
  }
  .van-button--info{
    background-color linear-gradient(136deg, #227FFF 0%, #316FFF 100%)
    border 1px solid linear-gradient(136deg, #227FFF 0%, #316FFF 100%)
  }
}
.VerificationStyle{
  width 420px
}
.getVerificationStyle{
  color #333333
  font-size 30px
  // padding 40px 0
}
</style>
